import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function InterestSection() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-168">
          {/* Left Column: Problem Awareness Text */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-169">
            <div className="flex items-center gap-2 mb-4" data-id="element-170">
              <AlertTriangle className="w-6 h-6 text-[#F57C00]" data-id="element-171" />
              <span className="text-[#F57C00] font-bold uppercase tracking-wider text-sm" data-id="element-172">
                De Uitdaging
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-173">
              Extra capaciteit nodig zonder in te leveren op kwaliteit?
            </h2>

            <div className="space-y-4 text-lg text-gray-600 leading-relaxed mb-8" data-id="element-174">
              <p data-id="element-175">
                In grootschalige infra- en elektrotechnische projecten is
                planning cruciaal. Deadlines zijn strak, veiligheid is leidend
                en technische fouten zijn kostbaar.
              </p>
              <p data-id="element-176">
                Wanneer interne capaciteit tekortschiet, is een betrouwbare
                onderaannemer essentieel. Niet alleen uitvoerend, maar ook
                meedenkend.
              </p>
            </div>

            <div className="p-6 bg-blue-50 rounded-xl border-l-4 border-[#2E78B6] mb-8" data-id="element-177">
              <p className="text-[#2E78B6] font-medium italic" data-id="element-178">
                "Wij sluiten naadloos aan op uw organisatie en werkwijze."
              </p>
            </div>

            <Button className="w-full sm:w-auto bg-[#F57C00] hover:bg-[#E56A00] text-white flex items-center justify-center gap-2" data-id="element-179">
              Bespreek uw project
              <ArrowRight className="w-5 h-5" data-id="element-180" />
            </Button>
          </motion.div>

          {/* Right Column: Image with Overlay Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-181">
            {/* Main Image */}
            <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-xl" data-id="element-182">
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-183"></div>
              <img src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80" alt="Industrial workers on site" className="w-full h-full object-cover" data-id="element-184" />

              {/* Floating Content Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg z-20 border-t-4 border-[#F57C00]" data-id="element-185">
                <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-186">
                  Plubos Kabeltechniek ondersteunt installateurs met:
                </h3>

                <ul className="space-y-3" data-id="element-187">
                  {['Grondwerk en kabeltracés', 'Laag- en middenspanningskabels', 'Glasvezel en datanetwerken', 'Elektrotechnische installaties', 'Brandwerende doorvoeringen'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-188">
                      <CheckCircle2 className="w-5 h-5 text-[#F57C00] flex-shrink-0 mt-0.5" data-id="element-189" />
                      <span className="text-gray-700 font-medium text-sm" data-id="element-190">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#F57C00]/10 rounded-full blur-2xl -z-10" data-id="element-191"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#2E78B6]/10 rounded-full blur-2xl -z-10" data-id="element-192"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}